module.exports = __webpack_public_path__ + "img/winerackdog03.1762bd99.jpg";